import type { MobileExperienceManifest } from "@verity-connect/contracts";

/** Decide presentation only. The manifest never authorizes the destination API. */
export function mobileTakeoverDestination(
  manifest: MobileExperienceManifest,
  pathname: string,
): string | null {
  if (pathname === "/mobile-entry" || pathname === "/mobile" || pathname.startsWith("/mobile/")) return null;
  if (manifest.selectedExperience !== "staff" || manifest.lifecycleMode !== "active") return null;
  return manifest.homePath;
}
